import styled from '@emotion/styled';
import { Box } from './box';
import { handyBreakpoint } from './breakpoints';

export const ModalContent = styled(Box)`
  padding: 24px;
  background: var(--colorBlueGray1100);
  border-radius: 8px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.2);
  width: calc(100% - 64px);
  max-width: 800px;

  max-height: calc(100% - 128px);
  overflow-y: auto;

  ${handyBreakpoint} {
    width: calc(100% - 16px);
    max-height: calc(100% - 32px);
  }
`;
